import { Box, MenuItem, TextField, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { datesMatchAnyPeriod } from "src/utils/date";

/**
 * t("shared.summaryPeriod.today")
 * t("shared.summaryPeriod.yesterday")
 * t("shared.summaryPeriod.3days")
 * t("shared.summaryPeriod.7days")
 * t("shared.summaryPeriod.14days")
 * t("shared.summaryPeriod.30days")
 * t("shared.summaryPeriod.this_month")
 * t("shared.summaryPeriod.last_month")
 * t("shared.summaryPeriod.custom")
 */

export type Period =
    | "today"
    | "yesterday"
    | "7days"
    | "14days"
    | "30days"
    | "this_month"
    | "last_month"
    | "custom";

export const period = [
    "today",
    "yesterday",
    "7days",
    "14days",
    "30days",
    "this_month",
    "last_month",
    "custom",
];

interface OwnProps {
    title?: string;
    enableCustom: boolean;
    handlePeriodChange?: (period: Period) => void;
}

const PeriodSelector: FC<OwnProps> = ({ title, enableCustom, handlePeriodChange }) => {
    const { t } = useTranslation();
    const [selectedPeriod, setSelectedPeriod] = useState<Period | null>("this_month");
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const from = searchParams.get("from");
        const to = searchParams.get("to");
        const matchedPeriod = datesMatchAnyPeriod(`${from}`, `${to}`);

        if (matchedPeriod && matchedPeriod !== selectedPeriod && from && to) {
            setSelectedPeriod(matchedPeriod);
        }
    }, [searchParams.get("from"), searchParams.get("to")]);

    return (
        <Box sx={{ width: 220 }}>
            {title && (
                <Typography variant="h6" component="h2" gutterBottom>
                    {title}
                </Typography>
            )}
            <TextField
                select
                fullWidth
                onChange={(e) => {
                    setSelectedPeriod(e.target.value as Period);
                    if (handlePeriodChange) handlePeriodChange(e.target.value as Period);
                }}
                value={selectedPeriod}
            >
                {period
                    .filter((sp) => sp !== "custom")
                    .map((summaryPeriod) => {
                        return (
                            <MenuItem key={summaryPeriod} value={summaryPeriod}>
                                {t("shared.summaryPeriod." + summaryPeriod)}
                            </MenuItem>
                        );
                    })}
                {enableCustom && (
                    <MenuItem value={"custom"}>{t("shared.summaryPeriod.custom")}</MenuItem>
                )}
            </TextField>
        </Box>
    );
};

export default PeriodSelector;
